<style lang="scss">
    $right-padding: 10px;
    $height: 10px;
    .progress-bar-wrapper {
        height: 0px;
        position: relative;
        padding: 0 $right-padding 0 0;
        .progress-bar-container {
            background: #5e5561;
            position: relative;
            cursor: pointer;
            height: $height;
            top: -5px;
            z-index: 299;
            .progress-bar {
                height: 100%;
                position: absolute;
                left: 0;
                transition: height 0.2s;
                border-radius: 0;
                .progress-handle {
                    position: absolute;
                    right: -21px;
                    width: 28px;
                    height: 28px;
                    border-radius: 50%;
                    top: -9px;
                    background:rgba(158,54,189,0.4);
                    .progress-handle-dark{
                        position: absolute;
                        width: 18px;
                        height: 18px;
                        border-radius: 50%;
                        margin: 5px;
                        background:rgba(158,54,189,1);
                    }
                }
            }
            &:after {
                /**
                    This :after block is an ad-hoc solution to fill
                    the right space of the progress bar container
                */
                display: block;
                position: absolute;
                content: "";
                width: $right-padding;
                height: $height;
                top: 0;
                right: -$right-padding;
                background-color: inherit;
                z-index: -1;
            }
        }
    }
</style>

<template>
    <div class="progress-bar-wrapper" id="progress-bar-wrapper">
        <div class="progress-bar-container" :style="$playerProgressContainerStyle">
            <div v-show="currentlyPlaying" class="progress-bar bg-purple" :style="[{'width': soundProgress } , $playerProgressBarStyle]" id="progress-bar">
                <div class="progress-handle" id="progress-bar-handle" :style="$progressBarrIndicatorLiteStyle">
                    <div class="progress-handle-dark" :style="$progressBarIndicatorDarkStyle"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Configure from './../mixins/configure'

    export default {
        props: ['currentTime'],
        mixins: [Configure],
        mounted() {
            this.$nextTick(() => {
                var hm = new Hammer.Manager(this.$el, {domEvents: true});
                hm.add(new Hammer.Swipe({ direction: Hammer.DIRECTION_HORIZONTAL, threshold: 0, velocity: 0 }));
                hm.add(new Hammer.Tap());
                var vm = this

                hm.on("hammer.input", function(ev) {
                    if (ev.eventType == 2) {
                        vm.setSeeking(ev)

                    } else if (ev.eventType == 4) {
                        vm.changeSoundPosition(ev)
                    }
                });
            })

        },
        data() {
            return {
                seeking: false
            }
        },
        computed: {
            playlistManager() {
                return this.$store.state.playlistManager
            },
            audioManager() {
                return this.playlistManager.audioManager
            },
            currentlyPlaying() {
                return this.playlistManager.getCurrentlyPlaying()
            },
            soundProgress() {
                if (this.seeking) {
                    return this.seeking
                }

                if (this.currentTime)
                {
                    let duration = this.audioManager.duration
                    let position = this.currentTime

                    return ((position / duration) * 100) + "%"
                }

                return 0
            },
            styleConfig() {
			    return this.$store.state.currentConfig.stylesConfig
            },
            progressBarStyle() {
			    if (this.styleConfig && this.styleConfig.player.progress_bar_background != undefined) {
			        return {
			            background: this.styleConfig.player.progress_bar_background.value
                    }
                }
            },
            
        },
        methods: {
            setSeeking(event) {
                this.seeking = event.center.x - (this.$el.offsetLeft + this.$el.offsetParent.offsetLeft) + "px"
            },
            changeSoundPosition(event) {
                if (this.currentlyPlaying) {
                    this.seeking = false
                    let position = this.getNewSoundPosition(event)
                    this.playlistManager.seek(position)
                }
            },
            getNewSoundPosition(event) {
                if (isNaN(this.audioManager.duration)) {
                    return 0
                }
                return Math.round(this.audioManager.duration * ((event.center.x - (this.$el.offsetLeft + this.$el.offsetParent.offsetLeft)) / this.$el.offsetWidth))
            },
            hexToRgbA(hex,alpha){
                var c;
                if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
                    c= hex.substring(1).split('');
                    if(c.length== 3){
                        c= [c[0], c[0], c[1], c[1], c[2], c[2]];
                    }
                    c= '0x'+c.join('');
                    return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+','+ alpha+')';
                }
                throw new Error('Bad Hex');
            }
        }
    }
</script>